import { Injectable } from "@angular/core";
import {Adapter} from "./adapter"

export class Widget {
    
    constructor(
        public id: number,
        public title: string, 
        public legend: string, 
        public data: any,
        public options?: any,
        public isChart: boolean = false,
        public isLoading: boolean = true
        ) {}
}